import type {
  Place,
  PlaceChanges,
  PlaceInput,
  UserData,
} from '../domain/types';

/**
 * A complete local-data snapshot. Keeping this contract independent from
 * IndexedDB makes it possible to add another persistence adapter later.
 */
export type AppSnapshot = UserData;

export interface PlacesRepository {
  load(): Promise<AppSnapshot>;
  createPlace(input: PlaceInput): Promise<Place>;
  updatePlace(id: string, changes: PlaceChanges): Promise<Place>;
  deletePlace(id: string): Promise<void>;
  setStationFavorite(stationId: string, favorite: boolean): Promise<void>;
  rememberTags(tags: readonly string[]): Promise<void>;

  /** Replaces places and settings in one transaction. */
  replaceAll(snapshot: AppSnapshot): Promise<void>;
}

export class PlaceNotFoundError extends Error {
  readonly placeId: string;

  constructor(placeId: string) {
    super(`Место с идентификатором «${placeId}» не найдено.`);
    this.name = 'PlaceNotFoundError';
    this.placeId = placeId;
  }
}
